import { Component, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { environment } from '../../../environments/environment'
import { AlertService } from '../../_services/index'
import { DataService } from '../../data.service';
import { NavigationService } from '../../navigation/navigation.service'
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
model: any = {};
btnDisable: boolean
  constructor(private alertService: AlertService,
    private dataService: DataService,
    private navigationService: NavigationService,
    public dialogRef: MatDialogRef<ChangePasswordComponent>,) { }

  ngOnInit(): void {
  }
  changePassword(form: any): any {
    if (form) {
      this.btnDisable = true

      this.navigationService.changePassword(this.model).subscribe(
        (data: any) => {
          this.alertService.success(data.message)
          this.dialogRef.close(this.model)
        },
        (err: any) => {
          this.btnDisable = false
          if (err.status === 400 || err.status === 401 || err.status === 404) {
            if (err.error.error) {
              this.alertService.error(err.error.error)
            }
            if (err.error.otp) {
              this.alertService.error(err.error.otp)
            }
          }
        }
      )
    }
  }
  closeModel(): void {
    this.dialogRef.close('')
  }
}
